import React, { lazy } from 'react';
import { Award } from 'lucide-react';
export function InstructorHighlight() {
  const instructors = [{
    name: 'Makkiyyah Sulayman',
    title: 'Executive Excellence Instructor',
    bio: 'With over a decade of experience supporting senior executives and building capacity in organizational leadership, Makkiyyah combines hands-on expertise with passion for developing future-ready Executive Assistants. She delivers practical strategies and relatable insights that empower learners to excel in their careers.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vfvsct7EYu8zbEiDsZVxqc/WhatsApp_Image_2025-11-26_at_23.12.55_decb0737.jpg'
  }, {
    name: 'Andrew Igbineweka',
    title: 'AI & Learning Design Specialist',
    bio: 'With almost a decade of experience strengthening organizations and developing future-ready talent, Andrew Igbineweka applies deep expertise in Artificial Intelligence, Instructional and Learning Experience Design, and Digital Media Strategy to reach over 100,000 learners in the Global South. He is a Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ)/ GOPA Worldwide Consultants–certified Trainer, facilitator and coach driving entrepreneurship development in Africa.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/h3a58Xzo5TJdtRFSTnxUzu/aaaaaaaaa.jpg'
  }, {
    name: 'Emem Akpan',
    title: 'Operations Excellence Instructor',
    bio: 'With years of experience strengthening teams and driving excellence in organizational operations, Emem brings a deep commitment to developing capable, future-ready professionals. She blends practical expertise with a passion for empowering learners through clear, actionable strategies that elevate their performance and confidence.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aejzWyH1Gd5G5vAQbykfZg/1761632405135.jpg'
  }, {
    name: 'Precious Imuwahen Ogbomo',
    title: 'Strategic Learning Advisor',
    bio: 'With almost 2 decades of experience shaping learning and talent ecosystems across Africa, Precious Imuwahen Ogbomo, pairs strategic expertise with a proven track record in public-sector transformation. She led the operationalization of the John Odigie Oyegun Public Service Academy and created the Jobberman Soft Skills Curriculum used to upskill over two million Africans. She delivers practical, inclusive learning solutions that strengthen leaders, teams, and organizations for long-term impact.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fgM76ZqeykjR9P5o8eiPfX/IMG_0273.jpg'
  }];
  return <section className="mb-12" data-id="element-345">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-346">
        Meet Your Instructors
      </h2>

      {/* Two rows of instructors - 2 per row */}
      <div className="space-y-6" data-id="element-347">
        {/* Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-348">
          {instructors.slice(0, 2).map((instructor, index) => <div key={index} className="bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 hover:shadow-xl transition-all duration-300" data-id="element-349">
              <div className="flex items-start gap-4" data-id="element-350">
                {/* Circular image with centered face */}
                <div className="flex-shrink-0" data-id="element-351">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-blue-100 shadow-lg" data-id="element-352">
                    <img src={instructor.image} alt={instructor.name} loading="lazy" className="w-full h-full object-cover" style={{
                  objectPosition: 'center center'
                }} data-id="element-353" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-354">
                  <div className="flex items-center gap-2 mb-1" data-id="element-355">
                    <Award className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-356" />
                    <h3 className="text-lg font-bold text-gray-900 truncate" data-id="element-357">
                      {instructor.name}
                    </h3>
                  </div>
                  <p className="text-blue-600 font-medium text-sm mb-2" data-id="element-358">
                    {instructor.title}
                  </p>
                  <p className="text-gray-700 leading-relaxed text-xs line-clamp-3" data-id="element-359">
                    {instructor.bio}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-360">
          {instructors.slice(2, 4).map((instructor, index) => <div key={index} className="bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-blue-300 hover:shadow-xl transition-all duration-300" data-id="element-361">
              <div className="flex items-start gap-4" data-id="element-362">
                {/* Circular image with centered face */}
                <div className="flex-shrink-0" data-id="element-363">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-blue-100 shadow-lg" data-id="element-364">
                    <img src={instructor.image} alt={instructor.name} loading="lazy" className="w-full h-full object-cover" style={{
                  objectPosition: 'center center'
                }} data-id="element-365" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-366">
                  <div className="flex items-center gap-2 mb-1" data-id="element-367">
                    <Award className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-368" />
                    <h3 className="text-lg font-bold text-gray-900 truncate" data-id="element-369">
                      {instructor.name}
                    </h3>
                  </div>
                  <p className="text-blue-600 font-medium text-sm mb-2" data-id="element-370">
                    {instructor.title}
                  </p>
                  <p className="text-gray-700 leading-relaxed text-xs line-clamp-3" data-id="element-371">
                    {instructor.bio}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}